import { Component } from 'react';
import _ from 'lodash';
import fileSaver from 'file-saver';
import Moment from 'moment';
import Service from '../services';
import { ProgressButton } from '../../../commons/ProgressButton';
import { DatePicker } from '../../../commons/controls';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';
import PropTypes from 'prop-types';

class NapiOsszesitoContent extends Component {
  constructor(props) {
    super(props);
    
    let now = new Date();
    now.setDate(now.getDate() -1);
    now.setUTCHours(0,0,0,0);

    this.state = {
      kibocsatoOptions: [],
      exportButtonLoading: false,
      tolValue: now,
      igValue: now,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.initForm();
      }
    }
  }

  initForm = () => {
    Service.initNyugtaFilter((err, res) => {
      if (!err) {
        this.setState({
          kibocsatoOptions: res[0].kibocsato && res[0].kibocsato.map(e => (
            <option key={e.id} value={e.id}>
              {e.nev + ' (' + e.cim + ')'}
            </option>
          ))
        });
      }
    });
  }

  exportXlsx = () => {
    console.log(this.state.kibocsatoValue);
    let kvb = {};
    if (this.state.tolValue || this.state.igValue) {
      kvb.sta = this.dateToTimezone(this.state.tolValue);
      kvb.end = this.dateToTimezone(this.state.igValue);
    }

    this.setState({ exportButtonLoading: true }, () => {
      Service.napiOsszesioXLSX(this.state.kibocsatoValue, kvb, (err, res) => {
        this.setState({ exportButtonLoading: false });
        if (!err) {
          this.props.globals.addSuccess('Napi összesítő XLSX letöltése...');
          fileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'NapiOsszesito_' + Moment().format('YYYYMMDD_HHmmSS') + '.xlsx');
        }
      });
    });
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleChangeKibocsato = (e, value) => {
    if (value && value.length !== 0) {
      this.setState({ kibocsatoValue: value });
    } else {
      this.setState({ kibocsatoValue: '' });
    }
  }

  render() {
    return (
      <RFForm>
         <div className="row">
           <div className="col-md-3">
             <RFField
               type="select"
               name="kibocsato"
               label={'Kibocsátó:'}
               onChange={this.handleChangeKibocsato}
               disabled={this.state.bizonylatszamValue}
               defaultSelect={<option value="">{'Válassz kibocsátót...'}</option>}
               selectOptions={this.state.kibocsatoOptions}
             />
           </div>
           <div className="col-md-2">
             <DatePicker
               label="Időszak kezdete (nap):"
               placeholder="éééé-hh-nn"
               onChange={(e, v) => this.handleDateInputChange(e, v, 'tolValue')}
               value={this.state.tolValue && new Date(this.state.tolValue)}
               name="datumKezdete"
               />
           </div>
           <div className="col-md-2">
             <DatePicker
               label="Időszak vége (nap):"
               placeholder="éééé-hh-nn"
               onChange={(e, v) => this.handleDateInputChange(e, v, 'igValue')}
               value={this.state.igValue && new Date(this.state.igValue)}
               name="datumVege"
             />
           </div>
            <div className="col-md-5">
              <ProgressButton className="margin-top-0" color="success" style={{ marginTop: 30, borderRadius: '.2rem' }} loading={this.state.exportButtonLoading} onClick={this.exportXlsx}>Exportálás XLSX-be</ProgressButton>
            </div>
         </div>
       </RFForm>
    );
  }
}

NapiOsszesitoContent.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  globals: PropTypes.object,
};

export default NapiOsszesitoContent;
